import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import { faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Select from "react-select";
import Layout from "../../components/common/Layout";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Alerts from "../layout/Alerts";
import Modal from "react-bootstrap/Modal";
import checkTime from "../../components/constants/CheckTime"
import { addAuditLog } from "../../components/AuditLog"
import { format } from "date-fns"

const Case = (props) => {
  const userId =
  JSON.parse(localStorage.getItem("user")) === null
    ? null
    : JSON.parse(localStorage.getItem("user"))[0].Id;

  const pagePermission =
      JSON.parse(localStorage.getItem("permission")) === null
      ? {IsCreate: false,
        IsDelete: false,
        IsUpdate: false,
        IsView: false}
      : JSON.parse(localStorage.getItem("permission")).filter(c => parseInt(c.MenuId) === 3)[0];
  const handleSort = (column, sortDirection) => {
      setSortedColumn(column.selector);
      setSortDirection(sortDirection);
    };
  
  const exportExcel = () => {
    //add Audit Log
    addAuditLog({ menu: "Case" , event: "Export Case", createBy: userId });

    const result = [];
    result.push(caseColumns.filter( c => columnsCheckFormData[c.selector]).map( x => x.selector));

    // (caseData).forEach(item => {
    //   let row = [];
    //   (Object.keys(columnsCheckFormData).filter(k => columnsCheckFormData[k])).forEach(key => {
    //     if(key === 'Image'){
    //       row.push(item['FilePath']);
    //     } else {
    //       row.push(item[key]);
    //     }
    //   });
    //   result.push(row);
    // });

    
    /* Prepared */
    let field = sortedColumn === 'CaseId' ? 'CaseReference' : sortedColumn;

    let filteredArray = caseData.filter(caseData => caseData.Matter != null ).slice();
    filteredArray.sort((a,b) => 
    {
      //console.log(sortedColumn);
      if(sortedColumn === 'CaseId')
      {
        setSortedColumn('CaseReference');
        
      }


     const aField = a[field] 
     const bField = b[field]

     let comparison = 0;
     
     if (aField > bField) {
      comparison = 1;
     } else if (aField < bField) {
      comparison = -1;
     }
   
     return sortDirection === 'desc' ? comparison * -1 : comparison;
   });

    setLoading(true);
    //console.log(`${filteredArray.map(x => x.CaseId)}`);
    //console.log(        `${encodeURIComponent(JSON.stringify(caseFormData))}`   );
    //console.log(result);
    /*
    axios.get(process.env.REACT_APP_API_URL + "/api/exportexcelcase/", {
      responseType: 'blob',
      params: {col : result, caseFormData}
     }).then(response => {
        let link = document.createElement('a');
        let day = new Date();
     
        link.href = window.URL.createObjectURL(new Blob([response.data], 
          {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));;
        link.download = day.toISOString().slice(0,10) + "-Case_export.xlsx";
        link.click();
     }).catch(error => {
        console.log(error)
     }).finally(() => {
      setLoading(false);
    });
     */
    axios.post(process.env.REACT_APP_EXL_URL + "/File/GetCaseExcelById",
      {
        CaseId : `${filteredArray.map(x => x.CaseId)}`,
        Cols: `${result}`,
        Key: 'xGhJjuMTLWfhq6Td8Q4RlAgdwdtwf4ch',
        SortBy: `${field}`,
        Sort: `${sortDirection}`,
        filter: `${encodeURIComponent(JSON.stringify(caseFormData))}`,
        },
        { responseType: 'blob' }

    ).then(response => {
      let link = document.createElement('a');
      let day = new Date();

      link.href = window.URL.createObjectURL(new Blob([response.data], 
        {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));;
      link.download = day.toISOString().slice(0,10) + "-Case_export.xlsx";
      link.click();
    }).catch(error => {
        console.log(error);
    }).finally(() => {
      setLoading(false);
    });  

    
       
  }

  const customSort = (rows, selector, direction) => {
    return rows.sort((rowA, rowB) => {

      if(selector === 'CaseId')
      {
        selector = 'CaseReference';
      }
      const aField = typeof selector === 'function' ? selector(rowA) : rowA[selector];
      const bField = typeof selector === 'function' ? selector(rowB) : rowB[selector];
    
      let comparison = 0;
    
      if (aField > bField) {
       comparison = 1;
      } else if (aField < bField) {
       comparison = -1;
      }
      //console.log(aField + " : " + bField + " : " + (direction === 'desc' ? comparison * -1 : comparison));

      return direction === 'desc' ? comparison * -1 : comparison;
     });
   };

  const caseColumns = [
    {
      cell: row => (
        <div>
          <Link to={"/cases/view/" + row.CaseId} target="_blank">
            <button className="btn btn-sm btn-primary">
              <i className="fa fa-eye"></i> View
            </button>
          </Link>
          <div className="btn-group dropright" style={{verticalAlign:"unset"}}>
            <button 
              type="button" 
              className="btn btn-sm btn-secondary dropdown-toggle ml-2" 
              id={row.CaseId === actionId ? "togget": "untogget"}
              data-toggle="dropdown" 
              aria-haspopup="true" 
              aria-expanded="false"
              //disabled
              value={row.CaseId}
              onClick={(e) => row.CaseId === actionId ? setActionId(0) : setActionId(e.target.value)}
            > Report  </button>
            {row.CaseId === actionId && <div 
              className="dropdown-menu" 
              style={{padding:"0", zIndex:100, display: "flex"}}> 
              <button className="btn-dropdown-item" type="button" ref={filingRef}
                style={{borderRadius:"3px 0 0 3px", backgroundColor:"rgb(117, 181, 47)"}}
                onClick={ () => {
                  setActionId(0);
                  //console.log('onclick Filing', row.CaseId);
                  //add Audit Log
                  addAuditLog({ menu: "Case" , event: "Export ReportFiling", createBy: userId });

                  axios
                    .get(process.env.REACT_APP_API_URL + "/api/reportfiling", {
                      params: {caseId : row.CaseId}
                    }).then(res => {
                      let link = document.createElement("a");
                      link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + res.data.base64Str;
                      link.download = row.CaseReference + "_Filing Report.docx";
                      link.click();
                    });
                }}
              >
                <i className="fa fa-file-word-o" /> Filing
              </button>
              <button className="btn-dropdown-item" type="button" ref={completionRef}
                id={row.CaseId + "_Completion"}
                style={{backgroundColor:"#08BDBD"}} 
                onClick={ () => {
                  setActionId(0);
                  //console.log('onclick Completion', row.CaseId);
                  //add Audit Log
                  addAuditLog({ menu: "Case" , event: "Export ReportCompletion", createBy: userId });

                  axios
                    .get(process.env.REACT_APP_API_URL + "/api/reportcompletion", {
                      params: {caseId : row.CaseId}
                    }).then(res => {
                      let link = document.createElement("a");
                      link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + res.data.base64Str;
                      link.download = row.CaseReference + "_Completion Report.docx";
                      link.click();
                    });
                }}
              > 
                <i className="fa fa-file-word-o" /> Completion
              </button>
              <button className="btn-dropdown-item" type="button" ref={renewalRef}
                id={row.CaseId + "_Renewal"}
                style={{borderRadius:"0 3px 3px 0", backgroundColor:"#F21B3F"}}
                onClick={ () => {
                  setActionId(0);
                  //console.log('onclick Renewal', row.CaseId);
                  //add Audit Log
                  addAuditLog({ menu: "Case" , event: "Export ReportRenewal", createBy: userId });

                  axios
                    .get(process.env.REACT_APP_API_URL + "/api/reportrenewal", {
                      params: {caseId : row.CaseId}
                    }).then(res => {
                      let link = document.createElement("a");
                      link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + res.data.base64Str;
                      link.download =  row.CaseReference + "_Renewal Completion Report.docx";
                      link.click();
                    });
                }}
              >
                <i className="fa fa-file-word-o" /> Renewal
              </button>
            </div>}
          </div>
        </div>
      ),
      ignoreRowClick: false,
      allowOverflow: true,
      width: "200px",
      button: true,
      show: 1
    },
    /*
    {
      name: "Case Reference",
      selector: "CaseReference",
      sortable: true,
      wrap: true
    },
    */
    {
      name: "Case Reference",
      selector: "CaseId",
      sortable: true,
      wrap: true,
      cell: row => (row.CaseReference)
    },
    {
      name: "Matter",
      selector: "Matter",
      sortable: true,
      wrap: true
    },
    {
      cell: row => (
        <img 
          height = "auto" 
          width="100px" 
          style={{ padding: "0px 5px", objectFit: "contain", maxHeight: "100px" }}
          alt="IMG"
          src = {
            row.FilePath === null || row.FilePath === undefined  ?
            "/images/logo/no-img.png"
            : "/images/uploads" + row.FilePath
          } />
      ),
      name: "Image",
      selector: "Image",
      sortable: true,
      wrap: true
    },
    {
      name: "Family",
      selector: "Family",
      sortable: true,
      wrap: true
    },
    {
      name: "Profit Centre",
      selector: "ProfitCentreName",
      sortable: true,
      wrap: true
    },
    {
      name: "Tax Treatment",
      selector: "TaxTreatmentName",
      sortable: true,
      wrap: true
    },
    {
      name: "Case Type",
      selector: "CaseTypeName",
      sortable: true,
      wrap: true
    },
    {
      name: "Case Status",
      selector: "CaseStatusName",
      sortable: true,
      cell: row => {
        switch (row.CaseStatusName){
          case 'Registered':
            return (<h6>
              <span className="badge badge-success text-left">{row.CaseStatusName}</span>
            </h6>);
          case 'Not yet filed' :
            return (<h6>
              <span className="badge badge-secondary text-left">{row.CaseStatusName}</span>
            </h6>);
          case 'Pending' :
              return (<h6>
                <span className="badge badge-info text-left">{row.CaseStatusName}</span>
              </h6>)
          case 'Dead' :
              return (<h6>
                <span className="badge badge-danger text-left">{row.CaseStatusName}</span>
              </h6>)
          default: 
            return (<span></span>)
        }
      }
    },
    {
      name: "Case Opening",
      selector: "CaseOpenDate",
      sortable: true,
      wrap: true,
      cell: row => ( format(new Date(row.CaseOpenDate), 'yyyy-MM-dd') )
    },
    {
      name: "Instructor",
      selector: "Instructor",
      sortable: true,
      wrap: true
    },
    /*
    {
      name: "Instructor Code",
      selector: "InstructorCode",
      sortable: true,
      wrap: true
    },
    */
    {
      name: "Debtor",
      selector: "Debtor",
      sortable: true,
      wrap: true
    },
    /*
    {
      name: "Debtor Code",
      selector: "DebtorCode",
      sortable: true,
      wrap: true
    },
    */
    {
      name: "Owner",
      selector: "Owner",
      sortable: true,
      wrap: true
    },
    /*
    {
      name: "Owner Code",
      selector: "OwnerCode",
      sortable: true,
      wrap: true
    },
    */
    {
      name: "Agent",
      selector: "Agent",
      sortable: true,
      wrap: true
    },
    /*
    {
      name: "Agent Code",
      selector: "AgentCode",
      sortable: true,
      wrap: true
    },
    */
    {
      name: "Refferal",
      selector: "Refferal",
      sortable: true,
      wrap: true
    },
    /*
    {
      name: "Refferal Code",
      selector: "RefferalCode",
      sortable: true,
      wrap: true
    },
    */
    {
      name: "Partner",
      selector: "Partner",
      sortable: true,
      wrap: true
    },
    /*
    {
      name: "Partner Code",
      selector: "PartnerCode",
      sortable: true,
      wrap: true
    },
    */
    {
      name: "Attorney",
      selector: "Attorney",
      sortable: true,
      wrap: true
    },
    /*
    {
      name: "Attorney Code",
      selector: "AttorneyCode",
      sortable: true,
      wrap: true
    },
    */
    {
      name: "Executive",
      selector: "Executive",
      sortable: true,
      wrap: true
    },
    /*
    {
      name: "Executive Code",
      selector: "ExecutiveCode",
      sortable: true,
      wrap: true
    },
    */
    {
      name: "Last Update By",
      selector: "LastUpdateBy",
      sortable: true,
      wrap: true
    },
    {
      name: "Last UpdateDate Time",
      selector: "LastUpdateDateTime",
      sortable: true,
      wrap: true
    },
    {
      name: "Create By",
      selector: "CreateBy",
      sortable: true,
      wrap: true
    },
    {
      name: "Create Date Time",
      selector: "CreateDateTime",
      sortable: true,
      wrap: true
    }
  ];
  const [loading, setLoading] = useState(false);
  const [taxTreatment, setTexTreatment] = useState([
    { value: 0, label: "Select All" }
  ]);
  const [caseStatus, setCaseStatus] = useState([
    { value: 0, label: "Select All" }
  ]);
  const [profitCentre, setProfitCentre] = useState([
    { value: 0, label: "Select All" }
  ]);
  const [caseType, setCaseType] = useState([{ value: 0, label: "Select All" }]);
  const [namesType, setNamesType] = useState([{ value: 0, label: "Select All" }]);
  const [officenumbertype, setOfficenumbertype] = useState([{ value: 0, label: "Select All" }]);
  const [caseFormData, setCaseFormData] = useState({
    caseReference: "",
    family: "",
    matter: "",
    ProfitCentreName: null,
    taxTreatment: null,
    caseType: null,
    caseStatus: null,
    startDate: null,
    endDate: null,
    nameType: 0,
    name: "",
    officialNumbersType: null,
    officialNumbers: ""
  });
  const [caseData, setCaseData] = useState([]);
  const [showManageColumns, setShowManageColumns] = useState(false);
  const [columnsCheckFormData, setcolumnsCheckFormdata] = useState({
    CaseId: 1,
    Matter: 1,
    Image: 1,
    Family: 0,
    ProfitCentreName: 0,
    TaxTreatmentName: 0,
    CaseTypeName: 0,
    CaseStatusName: 1,
    CaseOpenDate:1,
    Instructor: 0,
    //InstructorCode: 0,
    Debtor: 0,
    //DebtorCode: 0,
    Owner: 1,
    //OwnerCode: 1,
    Agent: 0,
    //AgentCode: 0,
    Refferal: 0,
    //RefferalCode: 0,
    Partner: 0,
    //PartnerCode: 0,
    Attorney: 0,
    //AttorneyCode: 0,
    Executive: 0,
    //ExecutiveCode: 0,
    LastUpdateBy: 0,
    LastUpdateDateTime: 0,
    CreateBy: 1,
    CreateDateTime: 1
  });
  //defult columns
  const [listColumnsShow, setListColumnsShow] = useState([]);
  const [actionId, setActionId] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);   

  const reloadCase = async () => {
    
    /* Prepared */
    setLoading(true);
    await axios.get(process.env.REACT_APP_API_URL + "/api/cases").then(res => {
      setCaseData(res.data);
    });
    setLoading(false);

  };
  useEffect(() => {
    checkTime();
    document.addEventListener("mousedown",  (e) => { checkTime(); });
    reloadCase();
    axios
      .get(process.env.REACT_APP_API_URL + "/api/taxtreatment/ddl")
      .then(res => {
        setTexTreatment([...taxTreatment, ...res.data]);
      });
    axios
      .get(process.env.REACT_APP_API_URL + "/api/casestatus/ddl")
      .then(res => {
        setCaseStatus([...caseStatus, ...res.data]);
      });
    axios
      .get(process.env.REACT_APP_API_URL + "/api/profitcentre/ddl")
      .then(res => {
        setProfitCentre([...profitCentre, ...res.data]);
      });
    axios.get(process.env.REACT_APP_API_URL + "/api/casetype/ddl").then(res => {
      setCaseType([ ...caseType, ...res.data]);
    });
    axios
      .get(process.env.REACT_APP_API_URL + "/api/casenametype/ddl")
      .then(res => {
        setNamesType([...namesType, ...res.data]);
      });
    //Load Type Offial Number DDL
    axios
      .get(process.env.REACT_APP_API_URL + "/api/officenumbertype/ddl")
      .then(res => {
        setOfficenumbertype([...officenumbertype, ...res.data]);
      });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setListColumnsShow(Object.keys(columnsCheckFormData).reduce((ret, curr) => 
    columnsCheckFormData[curr] ? [...ret, curr] : ret
    , []));
  },[columnsCheckFormData]);

  useEffect(() => {
    if (sortedColumn && sortDirection) {
      console.log(`DataTable is sorted by column: ${sortedColumn} in ${sortDirection} order.`);
    }
  }, [sortedColumn, sortDirection]);

  useEffect(() => {
    if(actionId !== 0){
      document.addEventListener("mousedown", (e) => {
        if ((filingRef.current && !filingRef.current.contains(e.target)) 
            && (completionRef.current && !completionRef.current.contains(e.target))
            && (renewalRef.current && !renewalRef.current.contains(e.target))) {
          setActionId(0);
        }
      });
    }
  },[actionId])

  const onChangeSearch = e =>
    setCaseFormData({ ...caseFormData, [e.target.name]: e.target.value });


  const submitsearch = () => {
    axios
      .get(process.env.REACT_APP_API_URL + "/api/cases", {
        params: caseFormData
      })
      .then(res => {
        setCaseData(res.data);
      });
  };
  const filingRef = useRef(null);
  const completionRef = useRef(null);
  const renewalRef = useRef(null);

  const onChangeCheckColumns = (e) => {
    setcolumnsCheckFormdata({ 
      ...columnsCheckFormData, [e.target.name] : !columnsCheckFormData[e.target.name]
    })
  }
  const checkInputManageColumn = (name) => 
    (<div key={name} className="col-sm-12 col-md-6">
        <input 
          type="checkbox" 
          className="checkboxCustom1"
          name={name}
          id={name} 
          defaultChecked={columnsCheckFormData[name]} 
          onChange={onChangeCheckColumns}
          />
        <label htmlFor={name}> {caseColumns.filter( c => c.selector === name)[0].name}</label> 
      </div>)

  return (
    <Layout activeLinkTo="/cases" menuId="3">
      <div className="container-fluid" style={{ minHeight: 500 }}>
        <Alerts />
        <div className="card border-secondary">
          <h5 className="card-header text-white bg-primary">Case</h5>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <label className="title control-label">Case Reference</label>
                <input
                  type="search"
                  className="form-control"
                  name="caseReference"
                  value={caseFormData.caseReference}
                  onChange={onChangeSearch}
                  onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                />
              </div>
              <div className="col-md-6">
                <label className="title control-label">Family</label>
                <input
                  type="search"
                  className="form-control"
                  name="family"
                  value={caseFormData.family}
                  onChange={onChangeSearch}
                  onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label className="title control-label">Title</label>
                <input
                  type="search"
                  className="form-control"
                  name="title"
                  value={caseFormData.title}
                  onChange={onChangeSearch}
                  onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                />
              </div>
              <div className="col-md-6">
                <label className="title control-label">Profit Centre</label>
                <Select
                  name="profitCentre"
                  onChange={e => {
                    setCaseFormData({ ...caseFormData, profitCentre: e.value });
                  }}
                  defaultValue={profitCentre[0]}
                  options={profitCentre}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label className="title control-label">Tax Treatment</label>
                <Select
                  name="taxTreatment"
                  onChange={e => {
                    setCaseFormData({ ...caseFormData, taxTreatment: e.value });
                  }}
                  defaultValue={taxTreatment[0]}
                  options={taxTreatment}
                />
              </div>
              <div className="col-md-6">
                <label className="title control-label">Case Type</label>
                <Select
                  name="caseType"
                  onChange={e => {
                    setCaseFormData({ ...caseFormData, caseType: e.value });
                  }}
                  defaultValue={caseType[0]}
                  options={caseType}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label className="title control-label">Case Status</label>
                <Select
                  name="caseStatus"
                  onChange={e => {
                    setCaseFormData({ ...caseFormData, caseStatus: e.value });
                  }}
                  defaultValue={caseStatus[0]}
                  options={caseStatus}
                />
              </div>
              <div className="col-md-6">
                <label className="title control-label">Date Range</label>
                <div className="input-group">
                  <DatePicker
                    dateFormat="dd-MMM-yyyy"
                    placeholderText="start date"
                    isClearable
                    selected={caseFormData.startDate}
                    maxDate={caseFormData.endDate}
                    onChange={date => {
                      setCaseFormData({ ...caseFormData, startDate: date });
                    }}
                    selectsStart
                    startDate={caseFormData.startDate}
                    endDate={caseFormData.endDate}
                    showYearDropdown
                    scrollableYearDropdown
                    customInput={
                      <input
                        className="form-control"
                        style={{
                          borderTopRightRadius: 0,
                          borderBottomRightRadius: 0
                        }}
                      />
                    }
                  />
                  <DatePicker
                    dateFormat="dd-MMM-yyyy"
                    placeholderText="end date"
                    isClearable
                    selected={caseFormData.endDate}
                    minDate={caseFormData.startDate}
                    onChange={date => {
                      setCaseFormData({ ...caseFormData, endDate: date });
                    }}
                    selectsEnd
                    startDate={caseFormData.startDate}
                    endDate={caseFormData.endDate}
                    showYearDropdown
                    scrollableYearDropdown
                    customInput={
                      <input
                        className="form-control"
                        style={{
                          borderTopLeftRadius: 0,
                          borderBottomLeftRadius: 0
                        }}
                      />
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label className="title control-label">Name</label>
                <div className="input-group">
                  <div className="form-control" style={{padding:0, borderStyle:"hidden"}}>
                    <Select 
                      name="nameType"
                      onChange={e => {
                        setCaseFormData({ ...caseFormData, nameType: e.value });
                      }}
                      defaultValue={namesType[0]}
                      options={namesType}
                    />
                  </div>
                  <input
                    type="search"
                    className="form-control"
                    name="name"
                    value={caseFormData.name}
                    onChange={onChangeSearch}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label className="title control-label">Official Numbers</label>
                <div className="input-group">
                  <div className="form-control" style={{padding:0, borderStyle:"hidden"}}>
                    <Select 
                      name="OfficialNumbersType"
                      onChange={e => {
                        setCaseFormData({ ...caseFormData, officialNumbersType: e.value });
                      }}
                      defaultValue={officenumbertype[0]}
                      options={officenumbertype}
                    />
                  </div>
                  <input
                    type="search"
                    className="form-control"
                    name="officialNumbers"
                    value={caseFormData.officialNumbers}
                    onChange={onChangeSearch}
                  />
                </div>
              </div>
            </div>
            <div className="row mt-2 float-right">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={submitsearch}
                >
                  <FontAwesomeIcon icon={faSearch} /> Search
                </button>
              </div>
            </div>
          </div>
        </div>
        <p>&nbsp;</p>
        <div className="card border-secondary">
          <h5 className="card-header text-white bg-primary">Data</h5>
          <div className="card-body">
            <div className="row">
              <div className="table-responsive">
                  <Link to="/cases/add" hidden={!pagePermission.IsCreate}>
                    <button type="button" className="btn btn-success">
                      <FontAwesomeIcon icon={faPlus} /> Add
                    </button>
                  </Link>
                  <button type="button" className="btn btn-primary ml-2" onClick={() => {setShowManageColumns(true)}}>
                    <i className="fa fa-cog"></i> Manage Columns
                  </button>
                  <button type="button" className="btn btn-primary mr-2" 
                    style={{position:"absolute", right:0}} 
                    onClick={() => exportExcel()} >
                    <i className="fa fa-external-link"></i> Export file
                  </button>
                <a href="#down" id="top" style={{position:"absolute", right:"0px", padding:"63px 17px 0 0", zIndex:"1"}}>
                  <i className="fa fa-arrow-down" style={{color:"#c8c8c8"}}/>
                </a>
                <DataTable
                  noHeader={true}
                  pagination={true}
                  onSort={handleSort}
                  sortFunction={customSort} 
                  paginationPerPage={50}
                  paginationRowsPerPageOptions={[10, 20, 50, 100]}
                  columns={caseColumns.filter(columns => listColumnsShow.includes(columns.selector)||columns.show === 1 )}
                  data={caseData.filter(caseData => caseData.Matter != null)}
                />
                <a href="#top" id="down" style={{position:"absolute", right:"0px", padding:"0 17px"}}>
                  <i className="fa fa-arrow-up" style={{color:"#c8c8c8"}}/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Manage Columns*/}
      <Modal
        //size="sm"
        dialogClassName="modal-w3 columnsManageCustom"
        show={showManageColumns}
        onHide={() => {
          setShowManageColumns(false);
        }}
        centered
      >
        <Modal.Header closeButton className="replaceCloseBtn">
          <Modal.Title><i className="fa fa-columns" /> Manage Columns</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              {Object.keys(columnsCheckFormData).map( (e) => checkInputManageColumn(e))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Modal Manage columns*/}

      {/* Modal Loading */}

   
      <Modal
          size="sm"
          dialogClassName="main-modal"
          show={loading}

          onHide={() => {
            setLoading(false);
          }}
          centered
        >
          
          <Modal.Body>
            <div className="text-center mt-2">
              <h1>
          <i className="fa fa-hourglass" /> </h1> <br/> Now processing a report, please wait a minute.
          
          </div>
          </Modal.Body>
        </Modal>
  
      {/* Modal Loading */}      
    </Layout>

  );
};

export default Case;
